module.exports = __webpack_public_path__ + "static/media/5.ab46b822.png";